/* EASY GAMES Policy Center · native Shopify policy enhancement */
(() => {
  const init = () => {
    const centers = Array.from(document.querySelectorAll('[data-eg-policy-center]'));
    const center = centers.find((node) => node.hasAttribute('data-eg-policy-pending')) || centers[0];
    if (!center || center.dataset.enhanced === 'true') return;

    const nativePolicy = document.querySelector('.shopify-policy__container');
    if (!nativePolicy) return;

    const main = document.getElementById('MainContent');
    const kind = center.dataset.policyKind || '';
    const policyBody = nativePolicy.querySelector('.shopify-policy__body .rte') || nativePolicy.querySelector('.shopify-policy__body');
    if (!main || !policyBody) return;

    centers.forEach((node) => {
      if (node !== center && node.dataset.enhanced === 'true') node.remove();
    });
    cleanupPreviousEnhancement(nativePolicy);

    if (center.parentNode !== main) {
      main.insertBefore(center, main.firstChild);
    }
    center.removeAttribute('data-eg-policy-pending');
    center.dataset.enhanced = 'true';
    nativePolicy.classList.add('eg-policy-native');

    const readingLayout = document.createElement('div');
    readingLayout.className = 'eg-policy-reading-layout';
    readingLayout.dataset.egPolicyGenerated = 'reading';
    copyThemeVariables(center, readingLayout);

    nativePolicy.parentNode.insertBefore(readingLayout, nativePolicy);
    readingLayout.appendChild(nativePolicy);

    decorateTables(policyBody);

    const headings = collectHeadings(policyBody, kind);
    const useToc = center.dataset.tocEnabled === 'true' && (kind === 'terms' || kind === 'privacy') && headings.length >= 3;

    if (useToc) {
      const tocTemplate = center.querySelector('template[data-eg-policy-toc-template]');
      if (tocTemplate) {
        const toc = tocTemplate.content.firstElementChild.cloneNode(true);
        toc.dataset.egPolicyGenerated = 'toc';
        const list = toc.querySelector('[data-eg-policy-toc-list]');
        buildToc(list, headings);
        readingLayout.insertBefore(toc, nativePolicy);
        observeHeadings(toc, headings);
      } else {
        readingLayout.classList.add('is-without-toc');
      }
    } else {
      readingLayout.classList.add('is-without-toc');
    }

    const helpTemplate = center.querySelector('template[data-eg-policy-help-template]');
    if (helpTemplate) {
      const help = helpTemplate.content.firstElementChild.cloneNode(true);
      help.dataset.egPolicyGenerated = 'help';
      copyThemeVariables(center, help);
      readingLayout.insertAdjacentElement('afterend', help);
    }

    center.querySelectorAll('template').forEach((template) => template.remove());
  };

  const cleanupPreviousEnhancement = (nativePolicy) => {
    document.querySelectorAll('[data-eg-policy-generated="help"]').forEach((node) => node.remove());

    const previousLayout = nativePolicy.closest('.eg-policy-reading-layout');
    if (previousLayout && previousLayout.parentNode) {
      previousLayout.parentNode.insertBefore(nativePolicy, previousLayout);
      previousLayout.remove();
    }

    nativePolicy.classList.remove('eg-policy-native');
    nativePolicy.querySelectorAll('.eg-policy-generated-heading').forEach((node) => {
      node.classList.remove('eg-policy-generated-heading');
      node.removeAttribute('data-eg-policy-level');
    });
  };

  const copyThemeVariables = (source, target) => {
    const style = getComputedStyle(source);
    [
      '--egpc-max-width', '--egpc-reading-width', '--egpc-radius', '--egpc-bg',
      '--egpc-surface', '--egpc-soft', '--egpc-ink', '--egpc-muted',
      '--egpc-accent', '--egpc-accent-2', '--egpc-border'
    ].forEach((property) => target.style.setProperty(property, style.getPropertyValue(property)));
  };

  const decorateTables = (body) => {
    body.querySelectorAll('table').forEach((table) => {
      if (table.parentElement && table.parentElement.classList.contains('eg-policy-table-wrap')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'eg-policy-table-wrap';
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  };

  const collectHeadings = (body, kind) => {
    const candidates = Array.from(body.querySelectorAll('h2, h3'));

    if (kind === 'terms') {
      Array.from(body.querySelectorAll('p')).forEach((paragraph) => {
        const text = normalizeText(paragraph.textContent);
        if (/^(PANORAMA|SECCI[ÓO]N\s+\d+\b)/i.test(text)) {
          paragraph.classList.add('eg-policy-generated-heading');
          paragraph.dataset.egPolicyLevel = '2';
          candidates.push(paragraph);
        }
      });
    }

    const unique = Array.from(new Set(candidates)).filter((node) => normalizeText(node.textContent).length > 0);
    unique.sort((a, b) => {
      if (a === b) return 0;
      const position = a.compareDocumentPosition(b);
      return position & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
    });

    const ids = new Set();
    return unique.map((node, index) => {
      const text = normalizeText(node.textContent);
      const existingBase = node.dataset.egPolicyOriginalId || node.id || slugify(text) || `seccion-${index + 1}`;
      if (!node.dataset.egPolicyOriginalId) node.dataset.egPolicyOriginalId = existingBase;
      let safeId = existingBase.startsWith('eg-policy-') ? existingBase : `eg-policy-${existingBase}`;
      let suffix = 2;
      while (ids.has(safeId) || (document.getElementById(safeId) && document.getElementById(safeId) !== node)) {
        safeId = `${existingBase.startsWith('eg-policy-') ? existingBase : `eg-policy-${existingBase}`}-${suffix++}`;
      }
      ids.add(safeId);
      node.id = safeId;
      const level = node.dataset.egPolicyLevel || (node.tagName === 'H3' ? '3' : '2');
      return { node, id: safeId, text, level };
    });
  };

  const buildToc = (list, headings) => {
    if (!list) return;
    headings.forEach((heading) => {
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = cleanTocLabel(heading.text);
      link.dataset.level = heading.level;
      link.addEventListener('click', () => {
        requestAnimationFrame(() => history.replaceState(null, '', `#${heading.id}`));
      });
      item.appendChild(link);
      list.appendChild(item);
    });
  };

  const observeHeadings = (toc, headings) => {
    if (!('IntersectionObserver' in window)) return;
    const links = Array.from(toc.querySelectorAll('a[href^="#"]'));
    const byId = new Map(links.map((link) => [decodeURIComponent(link.getAttribute('href').slice(1)), link]));
    const observer = new IntersectionObserver((entries) => {
      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
      if (!visible) return;
      links.forEach((link) => link.classList.remove('is-active'));
      const active = byId.get(visible.target.id);
      if (active) active.classList.add('is-active');
    }, { rootMargin: '-15% 0px -70% 0px', threshold: [0, 1] });
    headings.forEach(({ node }) => observer.observe(node));
  };

  const normalizeText = (value) => (value || '').replace(/\s+/g, ' ').trim();

  const cleanTocLabel = (value) => {
    const clean = normalizeText(value);
    if (clean.length <= 78) return clean;
    return `${clean.slice(0, 75).trim()}…`;
  };

  const slugify = (value) => normalizeText(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 70);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => requestAnimationFrame(init));
})();
